module.exports = __webpack_public_path__ + "static/media/histori.ee45ec03.png";